import winston from 'winston'
import buildDevLogger from './dev-logger'
import buildProdLogger from './prod-logger'
import { isProductionLogger } from '../utils'

const logger: winston.Logger = isProductionLogger() ? buildProdLogger(false) : buildDevLogger(false)

export default logger
